<template>
  <div :class="$style.outer">
    <div :class="$style.wrapper">
      <div :class="$style.score">
        {{ scoreNumber }}
      </div>
      <div :class="$style.text">
        {{ scoreText }}
      </div>
    </div>
  </div>
</template>

<script>
import { TweenMax } from 'gsap'

const plural = (number, one, two, five) => {
  let n = Math.abs(number)
  n %= 100
  if (n >= 5 && n <= 20) {
    return five
  }
  n %= 10
  if (n === 1) {
    return one
  }
  if (n >= 2 && n <= 4) {
    return two
  }
  return five
}

export default {
  name: 'Score',
  data() {
    return {
      proxyScore: this.score,
    }
  },
  computed: {
    score() {
      return this.$store.state.result
    },
    scoreNumber() {
      return this.proxyScore < 10 ? `0${Math.floor(this.proxyScore)}` : `${Math.floor(this.proxyScore)}`
    },
    scoreText() {
      const { proxyScore } = this
      return plural(proxyScore, 'балл', 'балла', 'баллов')
    },
  },
  watch: {
    score: {
      handler(score) {
        TweenMax.to(this, 0.3, { proxyScore: score })
      },
      immediate: true,
    },
  },
}
</script>
<style lang="scss" module>
@import './Score.sass';
</style>
